import * as React from 'react';
import { Image } from '@cian/ui-kit/image';

import styles from './Thumbnail.css';
import { IImageInfo } from '../../types/newbuilding';

interface IThumbnailProps {
  image: IImageInfo;
}

export const Thumbnail: React.FC<React.PropsWithChildren<IThumbnailProps>> = ({ image, children }) => {
  return (
    <div className={styles['thumbnail']}>
      <Image src={image.thumbnailUrl || image.fullUrl} objectFit="cover" borderRadius={0} />
      {children}
    </div>
  );
};
